/**
Drop this code into your HTML file where you want the image upload functionality.
This will add multiple image upload functionality with a preview and remove option.

<div class="post-images-v2">
    <input type="file" multiple name="post_images[]"
        accept=".jpg,.jpeg,.png,.gif" id="image-input">
    <div id="preview-container"></div>
</div>

Call the init function to initialize the image upload functionality
PostImages.init('create-edit-post-form', 'images/funcommunity/posts');

This library calls the ImageUploaderV2 library to upload images.
*/
window.PostImages = new function () {
    this.vars = {
        input: document.getElementById('image-input'),
        previewContainer: document.getElementById('preview-container'),
        files: [],
    };

    this.init = function (form_class, image_directory) {
        this.vars.input.addEventListener('change', (e) => {
            const newFiles = Array.from(e.target.files);

            if (PostImages.vars.files.length + newFiles.length > 10) {
                alert('You can only upload up to 10 images.');
                e.target.value = '';
                return;
            }

            this.vars.files = Array.from(e.target.files);
            this.renderPreviews();
            this.updateInputFiles();
        });

        jQuery('body').on('submit', '.' + form_class, (event) => {
            if (
                jQuery('form.' + form_class).find('input[name="post_type"]').val() == 'image' ||
                jQuery('form.' + form_class).find('input[name="post_has"]').val() == 'image'
            ) {
                event.preventDefault();

                ImageUploaderV2.uploadImages(
                    'form.' + form_class,
                    this.vars.files,
                    'input[name="post_images[]"]',
                    image_directory
                );
            }
        });

        Sortable.create(this.vars.previewContainer, {
            animation: 150,
            onEnd: () => {
                const reordered = [];
                this.vars.previewContainer.querySelectorAll('.preview-item').forEach(item => {
                    reordered.push(item.file);
                });
                this.vars.files = reordered;
                this.updateInputFiles();
            }
        });
    };

    this.updateInputFiles = function () {
        const dataTransfer = new DataTransfer();
        this.vars.files.forEach(file => dataTransfer.items.add(file));
        this.vars.input.files = dataTransfer.files;
    };

    this.renderPreviews = function () {
        this.vars.previewContainer.innerHTML = '';

        this.vars.files.forEach((file) => {
            const reader = new FileReader();

            reader.onload = (e) => {
                const item = document.createElement('div');
                item.classList.add('preview-item');
                item.file = file;

                const img = document.createElement('img');
                img.src = e.target.result;

                const removeBtn = document.createElement('button');
                removeBtn.innerText = '×';
                removeBtn.classList.add('remove-btn');
                removeBtn.onclick = () => {
                    this.vars.files = this.vars.files.filter(f => f !== file);
                    this.renderPreviews();
                    this.updateInputFiles();
                };

                item.appendChild(img);
                item.appendChild(removeBtn);
                this.vars.previewContainer.appendChild(item);
            };

            reader.readAsDataURL(file);
        });
    };
};
